import { failToast, warningToast } from '@utils/toast';
import * as Ids from '@utils/ids';
import { getCookie } from '@utiljs/cookie';
import * as LX from '@utils/lxWrapper';
import { updateURLParam } from '@utiljs/param';
import * as API from '../api';
import { getFrameByName, FRAME_NAME } from '../utils/subFrames';
// eslint-disable-next-line import/no-cycle
import { bridge } from '../utils/bridgePlatform';

// @ts-ignore
const getOffset = (Node, offset?) => {
    if (!offset) {
        offset = {};
        offset.top = 0;
        offset.left = 0;
    }
    if (Node === document.body || !Node) {
        //当该节点为body节点时，结束递归
        return offset;
    }
    offset.top += Node.offsetTop;
    offset.left += Node.offsetLeft;

    return getOffset(Node.offsetParent, offset); //向上累加offset里的值
};

const cspInitChat = (chatUrl: string) => {
    let finalChatUrl = chatUrl;
    // 补齐通参
    finalChatUrl = updateURLParam(finalChatUrl, 'wmToken', Ids.getToken());
    finalChatUrl = updateURLParam(finalChatUrl, 'wmPoiId', Ids.getWmPoiId());
    finalChatUrl = updateURLParam(finalChatUrl, 'acctId', Ids.getAcctId());

    if (window.csp) {
        window.csp.initChat({
            url: finalChatUrl,
            hideMiniChatButton: true,
            chatConfig: {
                style: {
                    right: '100px',
                    bottom: '50px',
                    zIndex: '100',
                },
            },
        });
    }
};

// @ts-ignore
const parentsUntil = (el, selector, filter) => {
    const result = [];
    const matchesSelector =
        el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

    // match start from parent
    el = el.parentElement;
    while (el && !matchesSelector.call(el, selector)) {
        if (!filter) {
            result.push(el);
        } else {
            if (matchesSelector.call(el, filter)) {
                result.push(el);
            }
        }
        el = el.parentElement;
    }
    return result;
};

let serviceMallFrameEl: HTMLIFrameElement | null = null;

const closeServiceHall = () => {
    if (serviceMallFrameEl) {
        document.body.removeChild(serviceMallFrameEl);
        serviceMallFrameEl = null;
    }
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
let doInitCustomerService = (url?: string) => {};

const serviceHallMessageHandler = (params: { type: 1 | 2; url?: string; closable?: boolean }) => {
    const { closable = true } = params;
    if (closable) {
        closeServiceHall();
    }

    if (params.type === 1 && params.url) {
        bridge.jumpTo({ href: params.url });
    }

    if (params.type === 2) {
        doInitCustomerService(params.url);
    }
};

const initCustomerService = (store: any) => {
    const wmPoiId = getCookie('wmPoiId');

    if (wmPoiId === '-1') {
        return;
    }

    const getSceneType: () => Promise<number> = () => {
        return API.getCustomerServiceScene().then(
            sceneRes => {
                const { matchedMenu } = store.getState().shellLeftMenu;
                const { menuName, subMenuName } = matchedMenu;
                let sceneType = 14; // 默认值
                // @ts-ignore
                sceneRes.forEach(function(record) {
                    if (record.pageName === menuName && record.subPageName === subMenuName) {
                        sceneType = record.sceneId;
                    }
                });

                return sceneType;
            },
            () => 14,
        );
    };

    // 第一次调用接口只判断是否命中灰度
    API.customerServiceInfo({ sceneType: 14 })
        .then(res => {
            if (res.showNewSCS === 1) {
                // 加载智能客服SDK
                const sdkScript = document.createElement('script');
                sdkScript.src = '//h5.dianping.com/app/cs-fe-pc-portal/lib/csp.js';
                document.body.appendChild(sdkScript);

                // 判断是否需要展示入口提示文案
                let entryText = '';
                if (res.script && res.script.show === 1 && res.script.value) {
                    entryText = res.script.value;
                } else if (res.text && res.text.show === 1 && res.text.value) {
                    entryText = res.text.value;
                }

                const entryElId = 'customer-service-new';
                let shouldHandleEntryClick = true;

                const entryDom = document.createElement('div');
                entryDom.id = entryElId;

                const template = `<div class="text-container"><span class="text ${entryElId}Text" style="display:none"></span></div><img id="customer-service-logo" draggable="false"/>`;
                entryDom.innerHTML = template;

                // 展示客服入口
                document.body.appendChild(entryDom);

                // @ts-ignore
                document.querySelector('#customer-service-logo').setAttribute(
                    'src',
                    // eslint-disable-next-line import/no-webpack-loader-syntax
                    require('!url-loader?limit=true!../../../assets/images/customer-service.gif'),
                );

                const text = document.querySelector(`.${entryElId}Text`);
                if (entryText !== '' && text) {
                    text.setAttribute('style', 'display: block');
                    text.textContent = entryText;
                }

                let chatUrl = '';

                doInitCustomerService = (url?: string) => {
                    // 初始化智能客服
                    chatUrl = url || '';
                    if (chatUrl === '') {
                        getSceneType().then(sceneType => {
                            // 拿匹配的 sceneType 请求最新的URL
                            API.customerServiceInfo({ sceneType }).then(infoRes => {
                                chatUrl = infoRes.scsUrl;
                                cspInitChat(chatUrl);
                            });
                        });
                    } else {
                        // 已经初始化过了，直接打开
                        cspInitChat(chatUrl);
                    }
                };

                // 点击入口 icon 打开客服弹框
                entryDom.addEventListener('click', () => {
                    LX.reportMC('b_waimai_e_5e7ny3cs_mc', 'c_waimai_e_fa4ps4ng', {
                        acctId: Ids.getAcctId(),
                    });
                    if (shouldHandleEntryClick) {
                        if (wmPoiId === '-1') {
                            warningToast('请切换到单门店访问');
                        } else {
                            if (res.isWmHall) {
                                // 初始化服务大厅
                                if (!serviceMallFrameEl) {
                                    serviceMallFrameEl = document.createElement('iframe');
                                    getSceneType().then(
                                        sceneType => {
                                            let finalServiceMallUrl = res.scsUrl;
                                            // 补齐通参
                                            finalServiceMallUrl = updateURLParam(
                                                finalServiceMallUrl,
                                                'token',
                                                Ids.getToken(),
                                            );
                                            finalServiceMallUrl = updateURLParam(
                                                finalServiceMallUrl,
                                                'wmPoiId',
                                                Ids.getWmPoiId(),
                                            );
                                            finalServiceMallUrl = updateURLParam(
                                                finalServiceMallUrl,
                                                'acctId',
                                                Ids.getAcctId(),
                                            );
                                            finalServiceMallUrl = updateURLParam(
                                                finalServiceMallUrl,
                                                '_source',
                                                'PC',
                                            );
                                            finalServiceMallUrl = updateURLParam(
                                                finalServiceMallUrl,
                                                'appType',
                                                '3',
                                            );
                                            finalServiceMallUrl = updateURLParam(
                                                finalServiceMallUrl,
                                                'sceneType',
                                                `${sceneType}`,
                                            );

                                            finalServiceMallUrl = updateURLParam(
                                                finalServiceMallUrl,
                                                'bsid',
                                                getCookie('bsid'),
                                            );
                                            if (serviceMallFrameEl) {
                                                serviceMallFrameEl.setAttribute(
                                                    'id',
                                                    'J-serviceMallFrame',
                                                );
                                                serviceMallFrameEl.setAttribute(
                                                    'name',
                                                    'J-serviceMallFrame',
                                                );
                                                serviceMallFrameEl.setAttribute(
                                                    'style',
                                                    'position: fixed; right: 10px; width: 375px; height: calc(100% -  60px); top: 60px; z-index: 1000; border-width: 0',
                                                );
                                                document.body.appendChild(serviceMallFrameEl);
                                                const target = getFrameByName(
                                                    FRAME_NAME.SERVICE_MALL,
                                                );
                                                if (!target) {
                                                    return;
                                                }
                                                target.location.replace(finalServiceMallUrl);
                                            }
                                        },
                                        () => {
                                            serviceMallFrameEl = null;
                                        },
                                    );
                                }
                                // 关闭智能客服
                                if (window.csp && window.csp.miniChatEle) {
                                    window.csp.miniChatEle();
                                }
                            } else {
                                doInitCustomerService();
                            }
                        }
                    }
                });

                // 入口 icon 支持拖拽改变位置
                let isDragging = false;
                let dragStartTime = 0;
                let pageX = 0;
                let pageY = 0;
                document.addEventListener('mousedown', e => {
                    if (
                        // @ts-ignore
                        e.target.id === entryElId ||
                        // @ts-ignore
                        parentsUntil(e.target)
                            .map(item => {
                                return item.id;
                            })
                            .join('')
                            .includes(entryElId)
                    ) {
                        isDragging = true;
                        dragStartTime = Date.now();
                        pageX = e.screenX;
                        pageY = e.screenY;

                        document
                            .querySelector('#hashframe')!
                            .setAttribute('style', 'pointer-events: none');
                    }
                });
                document.addEventListener('mousemove', e => {
                    if (isDragging) {
                        const dom = document.querySelector(`#${entryElId}`);
                        const curX = e.screenX;
                        const curY = e.screenY;
                        // const offsetInfo = $('#' + entryElId).offset();
                        const offsetInfo = getOffset(dom);

                        const top = Number(offsetInfo.top);
                        const left = Number(offsetInfo.left);
                        const right = left + 80;
                        const bottom = top + 80;
                        let diffX = curX - pageX;
                        // 左
                        if (diffX < 0 && left < 10) {
                            diffX = 0;
                        }
                        // 右
                        if (diffX > 0 && right > window.document.body.clientWidth - 10) {
                            diffX = 0;
                        }
                        let diffY = curY - pageY;
                        // 上
                        if (diffY < 0 && top < 10) {
                            diffY = 0;
                        }
                        // 下
                        if (diffY > 0 && bottom > window.document.body.clientHeight - 10) {
                            diffY = 0;
                        }
                        // @ts-ignore
                        dom.setAttribute('style', `top: ${top + diffY}px; left: ${left + diffX}px`);

                        pageX = curX;
                        pageY = curY;
                    }
                });
                document.addEventListener('mouseup', () => {
                    isDragging = false;
                    shouldHandleEntryClick = false;

                    document
                        .querySelector('#hashframe')!
                        .setAttribute('style', 'pointer-events: all');
                    // 防止拖拽结束触发点击事件
                    if (Date.now() - dragStartTime < 200) {
                        shouldHandleEntryClick = true;
                    }
                });
            }
        })
        .catch(() => {
            failToast('网络异常，请稍后再试');
            return [];
        });
};

export default initCustomerService;
export { serviceHallMessageHandler };
